<p-fieldset [legend]="collapsed ? 'Podrazine': ''" [(collapsed)]="collapsed" [toggleable]="true">
    <ng-container appObrasciViewProvider *ngIf="!collapsed">
        <app-fast-data-entry [item]="item"></app-fast-data-entry>
    </ng-container>
</p-fieldset>